// TODO: remove this and update panning logic once adding single + uploading orders has been moved to planning-actions
import { v4 as uuidv4 } from 'uuid';
import {
  VisitDtoModelType,
  PlanningActionMetadataDtoModelType,
  PlanningActionMetadataDtoModel,
} from '../models';
import { ActionType } from '../PlanningActions';

export const transformVisitAddedToPlanningAction = (visitAdded: VisitDtoModelType): PlanningActionMetadataDtoModelType => PlanningActionMetadataDtoModel.create({
  __typename: 'PlanningActionMetadataDto',
  actionUuid: visitAdded.uuid ? visitAdded.uuid : visitAdded.id,
  projectId: visitAdded.projectId,
  actionName: ActionType.addedSingleOrder,
  detail: `A visit with UUID ${visitAdded.uuid} was added`,
});

export const transformUploadedOrdersToPlanningAction = (): PlanningActionMetadataDtoModelType => PlanningActionMetadataDtoModel.create({
  __typename: 'PlanningActionMetadataDto',
  // Temp hack util TODO noted above is complete
  actionUuid: uuidv4(),
  actionName: ActionType.uploadOrders,
  detail: 'Finished uploading orders',
});
